import { makeVar } from '@apollo/client'

export type ErrorTracker = (() => void) | null

export const rvSalesErrorTracker = makeVar<ErrorTracker>(null)
export const rvSitePerformanceErrorTracker = makeVar<ErrorTracker>(null)
export const rvTransactionsErrorTracker = makeVar<ErrorTracker>(null)
